import BaseIcon from '@/src/assets/icons'
import { BaseButton } from '../buttons/BaseButton'
import { Menu, MenuButton, MenuGroup, MenuItem, MenuList } from '../ui/Menu'

// Generate years from current year - 10 to current year + 10
const generateYearOptions = (minDate?: Date, maxDate?: Date) => {
  const currentYear = new Date().getFullYear()
  const minYear = minDate ? minDate.getFullYear() : currentYear - 5
  const maxYear = maxDate ? maxDate.getFullYear() : currentYear + 2

  const years: string[] = []
  for (let year = minYear; year <= maxYear; year++) {
    years.push(year.toString())
  }
  return years
}

interface YearDropdownProps {
  value: string
  onChange: (value: string) => void
  minDate?: Date
  maxDate?: Date
  disabledYears?: number[]
}

export const DatePickerYearDropdown = ({ value, onChange, minDate, maxDate, disabledYears }: YearDropdownProps) => {
  const yearOptions = generateYearOptions(minDate, maxDate)
  const disabledYearSet = new Set(disabledYears ?? [])

  return (
    <Menu>
      <MenuButton
        as={BaseButton}
        isDisabled={yearOptions.length <= 1}
        width='100%'
        pr='6px'
        size='small'
        variant='secondary'
        text={value.toString()}
        iconRight={<BaseIcon name='chevronDown' />}
        sx={{ '.chakra-text': { minWidth: '27px', width: '100%', textAlign: 'left' } }}
      />
      <MenuList
        overflowY='auto'
        sx={{
          '&::-webkit-scrollbar': {
            width: '4px',
          },
          '&::-webkit-scrollbar-track': {
            width: '6px',
            background: '#f1f1f1',
          },
          '&::-webkit-scrollbar-thumb': {
            background: '#888',
            borderRadius: '24px',
          },
          scrollbarWidth: 'thin',
          scrollbarColor: '#888 #f1f1f1',
          maxHeight: '250px',
        }}
      >
        <MenuGroup>
          {yearOptions.map(year => (
            <MenuItem
              value={year}
              key={year}
              class='standard'
              onClick={() => onChange(year)}
              isSelected={value === year}
              isDisabled={disabledYearSet.has(Number(year))}
            >
              {year}
            </MenuItem>
          ))}
        </MenuGroup>
      </MenuList>
    </Menu>
  )
}
